import Injectable from '@/modules/shared/domain/di/injectable';
import { CreateDocumentRepository } from '../../../domain/repository/create-document-repository';

@Injectable()
export default class CreateDocumentDummyRepository implements CreateDocumentRepository {
  execute(): Promise<void> {
    return Promise.resolve();
  }
}
